import React, { useEffect, useMemo, useState } from "react";
import { apiFetch, API_BASE_URL } from "../auth/authClient";



function formatMaybeEpochDate(v) {
  if (v === null || v === undefined || v === "") return "";
  // když přijde číslo nebo číselný string -> epoch ms
  const n = typeof v === "number" ? v : (/^\d{11,13}$/.test(String(v)) ? Number(v) : NaN);
  const d = !Number.isNaN(n) ? new Date(n) : new Date(v);
  if (isNaN(d.getTime())) return String(v);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
}

function formatMaybeEpochDateTime(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = typeof v === "number" ? v : (/^\d{11,13}$/.test(String(v)) ? Number(v) : NaN);
  const d = !Number.isNaN(n) ? new Date(n) : new Date(v);
  if (isNaN(d.getTime())) return String(v);

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yy} ${hh}:${mi}`;
}

function formatDurationMinutes(mins) {
  const n = Number(mins);
  if (!n || n <= 0) return "";
  const h = n / 60.0;
  const txt = (Math.round(h * 2) / 2).toFixed(1).replace(".", ",");
  return `${txt} hod`;
}

function formatCzDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
}

export default function Zaklad({onOpenZakazka, openingId, goTab}) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [list, setList] = useState([]);

  const [view, setView] = useState("active"); // active | all
  const [q, setQ] = useState("");
  const [limit, setLimit] = useState(25);

  
  const [hoverId, setHoverId] = useState("");
async function load() {
    setLoading(true);
    setErr("");
    try {
      const out = await apiFetch("/api/kniha/seznam", { method: "GET" });

      // ✅ apiFetch může vrátit buď Response, nebo rovnou JSON objekt
      let j;
      if (out && typeof out.json === "function") {
        const r = out;
        j = await r.json().catch(() => ({}));
        if (!r.ok || !j?.ok) throw new Error(j?.error || `HTTP ${r.status}`);
      } else {
        j = out || {};
        if (!j?.ok) throw new Error(j?.error || "Neplatná odpověď z API");
      }

      setList(Array.isArray(j.list) ? j.list : []);
    } catch (e) {
      setErr(e?.message || "Chyba načtení");
      setList([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = useMemo(() => {
    const needle = (q || "").trim().toLowerCase();
    let out = Array.isArray(list) ? [...list] : [];

    // aktivní = vše kromě storno
    if (view === "active") out = out.filter((x) => ((x?.stav || "") && (x.fakturovano !== true)) !== "storno");

    if (needle) {
      out = out.filter((x) => {
        const s = [
          x?.id,
          x?.zesnulyJmeno,
          x?.zesnulyPrijmeni,
          x?.zesnulyJmenoPrijmeni,
          x?.vypravitel,
          x?.datumUmrti,
          x?.typ,
          x?.stav,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return s.includes(needle);
      });
    }

    out.sort((a, b) => Number(b?.updatedAt || b?.createdAt || 0) - Number(a?.updatedAt || a?.createdAt || 0));
    return out.slice(0, Math.max(1, Number(limit) || 25));
  }, [list, view, q, limit]);

  const headerBtn = (active) => ({
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #ddd",
    background: active ? "#111" : "#fff",
    color: active ? "#fff" : "#111",
    fontWeight: 900,
    cursor: "pointer",
  });

  return (
    <div style={{ padding: 14 }}>
      <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 6 }}>
        Základ = hlavní rozcestník (ABRA logika).
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
        <button style={headerBtn(false)} onClick={() => goTab && goTab("vstup")}>Nový pohřeb</button>
        <button style={headerBtn(false)} onClick={() => goTab && goTab("kniha")}>Kniha zemřelých</button>
        <button style={headerBtn(false)} onClick={() => goTab && goTab("obrad")}>Kalendář / Obřady</button>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 10 }}>
        <button style={headerBtn(view === "active")} onClick={() => setView("active")}>Aktivní (nezafakturováno)</button>
        <button style={headerBtn(view === "all")} onClick={() => setView("all")}>Vše (historie)</button>

        <div style={{ flex: 1 }} />

        <label style={{ fontWeight: 800 }}>
          Zobrazit{" "}
          <select value={limit} onChange={(e) => setLimit(Number(e.target.value))} style={{ padding: 6, borderRadius: 10 }}>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </label>

        <button onClick={load} style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", background: "#fff", fontWeight: 900, cursor: "pointer" }}>
          Obnovit
        </button>
      </div>

      <div style={{ marginBottom: 10 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Hledat (ID, zesnulý, pozůstalý, datum, typ)…"
          style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #ddd" }}
        />
      </div>

      {err && (
        <div style={{ padding: 10, borderRadius: 12, background: "#fff4f4", border: "1px solid #f3c3c3", marginBottom: 10 }}>
          <b>Chyba:</b> {err}
          <div style={{ marginTop: 6, fontSize: 12, opacity: 0.8 }}>
            Tip: zkontroluj, že jsi přihlášený a API běží (API_BASE_URL={String(API_BASE_URL)}).
          </div>
        </div>
      )}
        {openingId ? (
          <div style={{ marginBottom: 10, padding: 10, borderRadius: 12, border: "1px solid #ffe08a", background: "#fff6d6", fontWeight: 900 }}>
            Otevírám zakázku… <span style={{ fontWeight: 700 }}>({openingId})</span>
          </div>
        ) : null}


      <div style={{ overflowX: "auto", border: "1px solid #ddd", borderRadius: 12 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#fafafa" }}>
              {["Číslo dokladu","Datum pohřbu","Čas pohřbu","Délka pohřbu","Datum vytvoření","Zesnulý","Pozůstalý","Typ obřadu"].map((h) => (
                <th key={h} style={{ textAlign: "left", padding: 10, borderBottom: "1px solid #eee", fontWeight: 900 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ padding: 12 }}>Načítám…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={8} style={{ padding: 12 }}>Nic nenalezeno.</td></tr>
            ) : (
              rows.map((x) => (
                  <tr
                    key={x.id}
                    onClick={() => onOpenZakazka && onOpenZakazka(x.id)}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "#fafafa"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = ""; }}
                    style={{ cursor: "pointer" }}
                  >
                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2", fontWeight: 900 }}>{x.id}</td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.datumPohrebu || x.datumPohrbu || "")}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.casPohrebu || x.casPohrbu || "")}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.delkaPohrebu || x.delkaPohrbu || "")}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.datumVytvoreni || x.createdAt || "")}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {x.zesnulyJmenoPrijmeni || [x.zesnulyPrijmeni, x.zesnulyJmeno].filter(Boolean).join(" ").trim()}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.pozustaly || x.vypravitel || "")}
                    </td>

                    <td style={{ padding: 10, borderBottom: "1px solid #f2f2f2" }}>
                      {(x.typObradu || x.typ || "")}
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75 }}>
        Tip: klikni na řádek → otevře zakázku a přepne tě do „Finální objednávka“.
      </div>
    </div>
  );
}
